import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Patient } from "../patient";
import { BaseListService } from "../../../base/base-list.service";
import { StorageService } from "../../../common/service/storage.service";


@Injectable()
export class PatientListService extends BaseListService implements Resolve<string>{

    constructor(private afs1: AngularFirestore, private userServiceChild: StorageService) {
        super(afs1, userServiceChild);
        this.table = 'patient';
        this.orderBy = 'firstName';
    }

    /**
     * Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return  this.userServiceChild.getCookie('navigationType')
    }

    getSearchQueryWithText(): any {
        return this.getCollection(this.getCollectionPath(), ref => ref
            .where(this.patientSearchQuery(this.searchedText.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()), '==', true)
            .limit(1000));
    }

    getSearchQueryWithOutText(): any {
        return this.getCollection(this.getCollectionPath(), ref => ref
            .orderBy(this.orderBy)
            .limit(this.ROWS));
    }

    getFirstQuery(): any {

        return this.getCollection(this.getCollectionPath(), ref => ref
            .orderBy(this.orderBy)
            .limit(this.ROWS));
    }

    getNextQuery(): any {
        return this.getCollection(this.getCollectionPath(), ref => ref
            .orderBy(this.orderBy)
            .startAfter(this.latestEntry)
            .limit(this.ROWS));
    }

    getPrevQuery(): any {
        return this.getCollection(this.getCollectionPath(), ref => ref
            .orderBy(this.orderBy, 'desc')
            // Now you can use the latestEntry to query with startAfter
            .startAfter(this.startingEntry)
            .limit(this.ROWS));
    }

    getCollectionPath(): string {
        return 'lab/' + this.userServiceChild.getCookie("lab") + '/' + this.table;
    }

    patientSearchQuery(patient): string {
        return 'anyMap.' + patient;
    }

}
